import { createContext } from "react";

export const InventoriesProductoLogContext = createContext(null); 